import React from 'react'
import PropTypes from 'prop-types'

import Icon from '@components/Icon'
import Table from '@components/Table'
import Axios from '@components/Axios'
import IconButton from '@material-ui/core/IconButton'

import './style.scss'

const List = ({ list = [], setItem, updateList, ...props }) => {

  const columns = [
    { 
      title: 'CONSTRUCTION_SYSTEM_LIST_NAME',
      field: 'name',   
    },
    {
      title: 'POST_LIST_OPTIONS',
      className: 'options',
      component: item => {
        return (
          <>
            <IconButton onClick={() => setItem(item)} className="list-edit">
              <Icon size={30} name="edit" />
            </IconButton>
            <Axios
              api="constructionSystem"
              method="delete"
              others={item._id}
              onSuccess={updateList}
            >
              {({ submit }) => (
                <IconButton onClick={submit} className="list-delete">
                  <Icon size={30} name="delete_icon" />
                </IconButton>
              )}
            </Axios>
          </>
        )
      }
    }
  ]

  return (
    <div className="List">
      <Table {...props} data={list} columns={columns} title="CONSTRUCTION_SYSTEM_LIST_TABLE_TITLE" />
    </div>
  )
}

export default List

List.propTypes = {
  list: PropTypes.array,
  setItem: PropTypes.func,
  updateList: PropTypes.func
}
